import { FileCheck2, RefreshCw, ShieldCheck } from "lucide-react";
import { Link } from "react-router-dom";
import SecureMacPolicyLayout, { SecureMacPolicySection } from "@/components/SecureMacPolicyLayout";

export default function SecureMacSupport() {
  return (
    <SecureMacPolicyLayout
      eyebrow="SecureShield support"
      title="Start from the real setting, not a guess."
      description="Use SecureShield status, version and local diagnostics before sharing anything with support."
      seoTitle="SecureShield Support — LightningFlow"
      canonicalPath="/secureshield/support"
    >
      <p className="mb-8 text-sm leading-relaxed text-ink-600">
        Looking for LightningFlow Platform, Halo SuperVPN or SecureAI support?{" "}
        <Link className="underline underline-offset-4" to="/support">
          Open LightningFlow Support
        </Link>
        .
      </p>
      <div className="grid gap-px border border-ink-100 bg-ink-100 sm:grid-cols-3">
        {[
          [ShieldCheck, "Note the version", "Open SecureShield or SecureShield Pro and record the version and build shown in the app."],
          [RefreshCw, "Reproduce once", "Retry the check or fix once, then note which setting still needs attention."],
          [FileCheck2, "Export only if needed", "Review the local support record and share it only when you are comfortable with its contents."],
        ].map(([Icon, title, body]) => (
          <article key={title} className="bg-white p-6">
            <Icon className="h-5 w-5 text-electric" />
            <h2 className="mt-4 font-display text-xl font-bold">{title}</h2>
            <p className="mt-3 text-sm leading-relaxed text-ink-600">{body}</p>
          </article>
        ))}
      </div>
      <SecureMacPolicySection title="Purchase references">
        <p>
          For App Store purchases, use your Apple receipt. For SecureShield website edition or Pro, use the Stripe receipt
          email and your LightningFlow account email. Never send card numbers or passwords.
        </p>
        <p>
          <Link className="underline" to="/account">
            Open your LightningFlow account
          </Link>
          .
        </p>
      </SecureMacPolicySection>
      <SecureMacPolicySection title="Contact">
        <p>
          Email{" "}
          <a className="underline" href="mailto:contact@lightningflow.ai?subject=SecureShield%20support">
            contact@lightningflow.ai
          </a>{" "}
          with the product edition, version/build, macOS version, chip (Intel or Apple Silicon) and a short
          description of the issue. Diagnostics are not transmitted automatically.
        </p>
      </SecureMacPolicySection>
      <SecureMacPolicySection title="Company">
        <p>TripleThree Global Pty Ltd trading as LightningFlow · South Australia.</p>
      </SecureMacPolicySection>
    </SecureMacPolicyLayout>
  );
}
